import {API_HOST_NAME} from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useDeploymentsResources = (teamId, projectId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/deployments`;
  return useAuthenticatedResources(url)
}

export default useDeploymentsResources;
